<template>
  <section class="details">
    <div class="container">
      <div v-if="!isMobile" class="tabs">
        <div class="tabs__titles-wrapper">
          <h4
            v-for="tab in tabs"
            :key="tab.id"
            class="tabs__title"
            :class="{ 'tabs__title--active': activatedTab === tab.id }"
            @click="activateTab(tab.id)"
            v-html="tab.title"
          />
        </div>
        <div class="tabs__text-wrapper rich-text-wrapper">
          <div v-if="activatedTab === 'details'" class="tabs__text">
            <RichRenderer :richTextData="tabs.details.text" />
          </div>
          <div v-if="activatedTab === 'quality'" class="tabs__text">
            <div
              v-for="quality in tabs.quality.sectionsList"
              :key="quality.title"
              class="tabs__subitem-wrapper"
            >
              <h4 class="text-color-navy tabs__subitem--title text-h4" v-html="quality.title" />
              <div v-for="item in quality.list" :key="item.title" class="tabs__subitem">
                <RichRenderer v-if="item.paragraphRich" :richTextData="item.paragraphRich" />
                <resource-item
                  v-if="item.payloadUrl || item.slug"
                  class="tabs__resources--item"
                  :data="item"
                  :isRichDescription="true"
                  @loginGatedResourceRequested="onLoginGatedResourceRequested"
                />
              </div>
            </div>
          </div>
          <div v-if="activatedTab === 'faq'" class="tabs__text">
            <div v-for="faq in tabs.faq.list" :key="faq.title" class="tabs__subitem">
              <div v-if="faq.includes" class="tabs__subitem-wrapper">
                <h4 class="text-color-navy tabs__subitem--title text-h4" v-html="faq.title" />
                <accordion
                  v-for="(item, n) in faq.includes.map((el) => el.fields).filter((el) => el)"
                  :key="`${item.title}-${n}`"
                >
                  <template #header>
                    <div class="text-h4 text-color-navy" v-html="item.title" />
                  </template>
                  <template #main>
                    <RichRenderer :richTextData="item.paragraphRich" :addWrapClass="false" />
                  </template>
                </accordion>
              </div>
              <div v-else class="tabs__subitem-wrapper">
                <accordion>
                  <template #header>
                    <div class="text-h4 text-color-navy" v-html="faq.title" />
                  </template>
                  <template #main>
                    <RichRenderer :richTextData="faq.paragraphRich" :addWrapClass="false" />
                  </template>
                </accordion>
              </div>
            </div>
          </div>
          <div v-if="activatedTab === 'resources'" class="tabs__text tabs__resources">
            <div
              v-for="resourceSection in tabs.resources.sectionsList"
              :key="resourceSection.title"
              class="tabs__subitem-wrapper"
            >
              <div class="tabs__subitem">
                <h4
                  class="text-color-navy tabs__subitem--title text-h4"
                  v-html="resourceSection.title"
                />
                <resource-item
                  v-for="resource in resourceSection.list"
                  :key="resource.title"
                  :data="resource"
                  :isRichDescription="true"
                  class="tabs__resources--item"
                  @loginGatedResourceRequested="onLoginGatedResourceRequested"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMobile" class="tabs">
        <div class="tabs__titles-wrapper">
          <div class="tabs__item-wrapper">
            <h4
              v-if="tabs.details"
              class="tabs__title"
              :class="{ 'tabs__title--active': activatedTab === 'details' }"
              @click="activateTab('details')"
              v-html="tabs.details.title"
            />
            <div
              v-if="activatedTab === 'details'"
              class="tabs__text-wrapper rich-text-wrapper tabs__resources"
            >
              <RichRenderer :richTextData="tabs.details.text" />
            </div>
            <h4
              v-if="tabs.quality"
              class="tabs__title"
              :class="{ 'tabs__title--active': activatedTab === 'quality' }"
              @click="activateTab('quality')"
              v-html="tabs.quality.title"
            />
            <div
              v-if="activatedTab === 'quality'"
              class="tabs__text-wrapper rich-text-wrapper tabs__resources"
            >
              <div
                v-for="quality in tabs.quality.sectionsList"
                :key="quality.title"
                class="tabs__subitem-wrapper"
              >
                <h4 class="text-color-navy tabs__subitem--title text-h4" v-html="quality.title" />
                <div v-for="item in quality.list" :key="item.title" class="tabs__subitem">
                  <RichRenderer v-if="item.paragraphRich" :richTextData="item.paragraphRich" />
                  <resource-item
                    v-if="item.payloadUrl || item.slug"
                    :data="item"
                    :isRichDescription="true"
                    class="tabs__resources--item"
                    @loginGatedResourceRequested="onLoginGatedResourceRequested"
                  />
                </div>
              </div>
            </div>
            <h4
              v-if="tabs.faq"
              class="tabs__title"
              :class="{ 'tabs__title--active': activatedTab === 'faq' }"
              @click="activateTab('faq')"
              v-html="tabs.faq.title"
            />
            <div v-if="activatedTab === 'faq'" class="tabs__text-wrapper rich-text-wrapper">
              <div v-for="faq in tabs.faq.list" :key="faq.title" class="tabs__subitem">
                <div v-if="faq.includes" class="tabs__subitem-wrapper">
                  <h4 class="text-color-navy tabs__subitem--title text-h4" v-html="faq.title" />
                  <accordion
                    v-for="(item, n) in faq.includes.map((el) => el.fields).filter((el) => el)"
                    :key="`${item.title}-${n}`"
                  >
                    <template #header>
                      <div class="text-h4 text-color-navy" v-html="item.title" />
                    </template>
                    <template #main>
                      <RichRenderer :richTextData="item.paragraphRich" :addWrapClass="false" />
                    </template>
                  </accordion>
                </div>
                <div v-else class="tabs__subitem-wrapper">
                  <accordion>
                    <template #header>
                      <div class="text-h4 text-color-navy" v-html="faq.title" />
                    </template>
                    <template #main>
                      <RichRenderer :richTextData="faq.paragraphRich" :addWrapClass="false" />
                    </template>
                  </accordion>
                </div>
              </div>
            </div>
            <h4
              v-if="tabs.resources"
              class="tabs__title"
              :class="{ 'tabs__title--active': activatedTab === 'resources' }"
              @click="activateTab('resources')"
              v-html="tabs.resources.title"
            />
            <div
              v-if="activatedTab === 'resources'"
              class="tabs__text-wrapper rich-text-wrapper tabs__resources"
            >
              <div
                v-for="resourceSection in tabs.resources.sectionsList"
                :key="resourceSection.title"
                class="tabs__subitem"
              >
                <div class="tabs__subitem-wrapper">
                  <h4
                    class="text-color-navy tabs__subitem--title text-h4"
                    v-html="resourceSection.title"
                  />

                  <resource-item
                    v-for="resource in resourceSection.list"
                    :key="resource.title"
                    :data="resource"
                    class="tabs__resources--item"
                    @loginGatedResourceRequested="onLoginGatedResourceRequested"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="relatedProducts && relatedProducts.length" class="related-products">
        <h3
          class="text-color-navy related-products__title text-h6"
          v-html="$t('product.relatedSectionTitle')"
        />
        <div class="related-products__items-wrapper">
          <product-item
            v-for="(item, n) in relatedProducts"
            :key="`${item.title}-${n}`"
            class="related-products__item"
            :item="item"
          />
        </div>
      </div>
    </div>

    <transition name="modal">
      <login-gated-resource-modal
        v-if="isLoginGatedResourceModalVisible"
        :isGuestAccessVisible="!!loginGatedResourceData.guestUrl"
        @loggedIn="openLoginGatedResource('loggedIn')"
        @guestAccessRequested="openLoginGatedResource('guest')"
        @close="isLoginGatedResourceModalVisible = false"
      />
    </transition>
  </section>
</template>
<script>
import Accordion from '@/components/common/Accordion.vue'
import ProductItem from '@/components/common/ProductItem.vue'

import LoginGatedResourceModal from '@/components/auth/LoginGatedResourceModal.vue'
import ResourceItem from '@/components/resources/pages/ResourceItem.vue'

import { useLoginGatedResource } from '@/composables/useLoginGatedResource'
import { useScreenWidth } from '@/composables/useScreenWidth'
export default {
  name: 'ProductDetailsTabs',
  components: {
    Accordion,
    LoginGatedResourceModal,
    ResourceItem,
    ProductItem,
  },
  props: {
    tabs: {
      type: Object,
      default: () => ({}),
    },
    relatedProducts: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const {
      loginGatedResourceData,
      isLoginGatedResourceModalVisible,
      onLoginGatedResourceRequested,
      openLoginGatedResource,
    } = useLoginGatedResource()
    const { isMobile } = useScreenWidth()

    return {
      loginGatedResourceData,
      isLoginGatedResourceModalVisible,
      onLoginGatedResourceRequested,
      openLoginGatedResource,
      isMobile,
    }
  },
  data() {
    return {
      activatedTab: '',
    }
  },
  mounted() {
    if (!this.isMobile) this.activatedTab = this.tabs?.details?.id || ''
  },
  methods: {
    activateTab(tabId) {
      this.activatedTab = tabId
    },
  },
}
</script>
